import {AppBar, Toolbar, Button, Box, Grid, Container, IconButton, Stack, Tooltip} from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWorkOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {NavLink, Outlet, redirect, useNavigate, useNavigation} from 'react-router-dom';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import './styles.css';
import useMdDown from '../hooks/useRespCheck';
import LogoutIcon from '@mui/icons-material/Logout';
import AuthProvider from '../hooks/authProvider';
import api from '../hooks/useApi';
import {useState, useEffect} from "react";
import PageTitle from "../components/PageTitle";
import {isPartner, isSuperAdmin} from '../auth/permissions';

const links = [
    {
        'link': '/calendar',
        'label': 'Календар',
    },
    {
        'link': '/new-object',
        'label': 'Новий об\'єкт',
    },
    {
        'link': '/owners',
        'label': 'Власники',
    },
    // {
    //     'link': '/tariffs',
    //     'label': 'Тарифи',
    // },
    /*{
        'link': '/prices',
        'label': 'Ціни',
    },*/
    /*{
        'link': '/restrictions',
        'label': 'Обмеження',
    },*/
    {
        'link': '/objects',
        'label': 'Мої локації',
    },
    {
        'link': '/',
        'label': 'Модуль бронювання',
    },

    {
        'link': '/orders',
        'label': 'Замовлення',
    },

    {
        'link': '/docs',
        'label': 'Документація',
    },
    {
        'link': '/adminH123H/publication',
        'label': 'Публікація об’єктів',
        'superadminOnly': true,
    },
    /*{
        'link': '/test',
        'label': 'ТЕСТ'
    },*/
]

export async function loader({request, params}) {
    if (!(await AuthProvider.checkAuth())) {
        const params = new URLSearchParams();
        params.set("from", new URL(request.url).pathname);
        return redirect("/login?" + params.toString());
    }
    //console.log(AuthProvider.user)
    return null;
}

export default function Menu() {
    const navigation = useNavigation();
    const navigate = useNavigate();
    // const [loading, setLoading] = useState(true);
    // const [userGroups, setUserGroups] = useState([]);
    const [isSuperStaffUser, setIsSuperStaffUser] = useState(false);
    const [isPartnerUser, setIsPartnerUser] = useState(false);
    const isMobile = useMdDown(); // ✅ Вызываем хук ОДИН раз

    // useEffect(() => {
    //     const fetchUserData = async () => {
    //         try {
    //             const accessToken = getCookie("access");
    //             if (!accessToken) {
    //                 console.error("Нет access_token в cookies!");
    //                 navigate("/login");
    //                 return;
    //             }
    //
    //             const response = await api.get("/api/user/profile/", {
    //                 headers: {Authorization: `Bearer ${accessToken}`},
    //             });
    //
    //             console.log("Ответ от API:", response.data.groups);
    //             setUserGroups(response.data.groups);
    //         } catch (error) {
    //             if (error.response && error.response.status === 401) {
    //                 console.error("Токен недействителен! Перенаправляем на логин...");
    //                 navigate("/login");
    //             } else {
    //                 console.error("Ошибка загрузки пользователя:", error);
    //             }
    //         } finally {
    //             setLoading(false);
    //         }
    //     };
    //
    //     fetchUserData();
    // }, []);


    // const filteredLinks =
    //     userGroups.map(Number).includes(1) || userGroups.map(Number).includes(2)
    //         ? links
    //         : [{link: "/", label: "Модуль бронювання"}];

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const accessToken = getCookie("access");
                if (!accessToken) {
                    console.error("Нет access_token в cookies!");
                    navigate("/login");
                    return;
                }
                //     setUserGroups(true); // Временно включаем все ссылки
                // }, []); // Выполняем один раз при монтировании

                const response = await api.get("/api/user/profile/", {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                AuthProvider.user = response.data;
                setIsSuperStaffUser(Boolean(response.data.is_superadmin));
                setIsPartnerUser(Boolean(response.data.is_partner));
            } catch (error) {
                if (error.response?.status === 401) {
                    console.error("Токен недействителен! Перенаправляем на логин...");
                    navigate("/login");
                } else {
                    console.error("Ошибка загрузки пользователя:", error);
                }
            }
        };

        fetchUserData();
    }, [navigate]);

    const currentUser = AuthProvider.user;
    const filteredLinks = isSuperAdmin(currentUser)
        ? links
        : isPartner(currentUser)
            ? links.filter((link) => ["Календар", "Новий об'єкт", "Мої локації", "Замовлення", "Модуль бронювання"].includes(link.label))
            : [{link: "/", label: "Модуль бронювання"}];

    // if (loading) {
    //     return <div>Загрузка...</div>;
    // }

    return (
        <>
            <PageTitle title="Панель керування" />
            {!isMobile && ( // ✅ Используем переменную вместо вызова хука
                <Box sx={{flexGrow: 1}}>
                    <AppBar elevation={0} position="static" sx={{backgroundColor: "white", color: "black"}}>
                        <Toolbar sx={{justifyContent: "space-between"}}>
                            <Box className="flex-placeholder"/>
                            <Box className="box-links">
                                {filteredLinks.length ? (
                                    filteredLinks.map((link) => (
                                        <Button
                                            key={link.label}
                                            component={NavLink}
                                            to={link.link}
                                            variant="text"
                                            color="inherit"
                                            className="nav-link"
                                            sx={{
                                                textTransform: "none",
                                                mx: 2,
                                                "&:hover": {textDecoration: "underline"},
                                            }}
                                            disableRipple
                                        >
                                            {link.label ? link.label : <i>Unknown</i>}
                                        </Button>
                                    ))
                                ) : (
                                    <p>
                                        <i>No links</i>
                                    </p>
                                )}
                            </Box>
                            <Box>
                                <Stack direction="row">
                                    <Button
                                        startIcon={<AccountCircleOutlinedIcon/>}
                                        component={NavLink}
                                        to="/profile/details"
                                        color="inherit"
                                        variant="text"
                                        className="nav-link"
                                    >
                                        {AuthProvider.user?.name || "Профіль"}
                                    </Button>

                                    <Tooltip title="Вийти">
                                        <IconButton onClick={() => navigate("/logout")} color="inherit"
                                                    className="nav-link">
                                            <LogoutIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </Box>
                        </Toolbar>
                    </AppBar>
                </Box>
            )}
            <Box className={navigation.state === "loading" ? "loading" : ""}>
                <Outlet/>
            </Box>
            {isMobile && (isSuperStaffUser || isPartnerUser) ? (
                <Box className="mobile_downmenu_wrapper">
                    <Box className="spacer_bottom" style={{height: "67px"}}/>
                    <Box className="zIndex9999" sx={{flexGrow: 1}}>
                        <AppBar position="fixed" color="backgrounds" sx={{top: "auto", bottom: 0}}>
                            <Container maxWidth="md">
                                <Toolbar>
                                    <Grid container spacing={1} style={{display: "flex", justifyContent: "end"}}>
                                        <Grid item xs={2}>
                                            <NavLink to="/mobile/objects">
                                                <IconButton size="large">
                                                    <HomeWorkIcon fontSize="large"/>
                                                </IconButton>
                                            </NavLink>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <NavLink to="/calendar">
                                                <IconButton size="large">
                                                    <CalendarMonthIcon fontSize="large"/>
                                                </IconButton>
                                            </NavLink>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <NavLink to="/mobile/owners">
                                                <IconButton size="large">
                                                    <PeopleIcon fontSize="large"/>
                                                </IconButton>
                                            </NavLink>
                                        </Grid>
                                    </Grid>
                                </Toolbar>
                            </Container>
                        </AppBar>
                    </Box>
                </Box>
            ) : (!isMobile ? (
                <Box style={{marginTop: "150px"}} className="bottom-spacer"/>
            ) : null)}
        </>
    );
}

function getCookie(name) {
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
